'use client';

import { PricingTable as ClerkPricingTable } from '@clerk/nextjs';

const PricingTable = () => {
  return (
    <div>
      <ClerkPricingTable />
    </div>
  );
};

export default PricingTable;
